import axios, { AxiosError } from 'axios';
import { toast } from 'sonner';

const baseURL = (import.meta.env.VITE_API_URL || '') + '/api/v1';

export const api = axios.create({ baseURL, withCredentials: false, timeout: 30_000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('census.accessToken');
  if (token) {
    config.headers = config.headers ?? {};
    (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError<any>) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
      localStorage.removeItem('census.accessToken');
      window.location.href = '/login';
      return Promise.reject(err);
    }
    // Callers can set _suppressGlobalError: true in config to handle errors
    // inline (e.g. the Claude review panel which shows errors in its own UI).
    if ((err.config as any)?._suppressGlobalError) return Promise.reject(err);

    const data = err.response?.data as any;
    const status = err.response?.status ?? 0;
    let msg: string;
    if (status >= 500) {
      // Never expose internal server details (stack traces, DB errors, etc.)
      // to end users. Log the original error for operators.
      console.error('[API 5xx]', status, data);
      msg = 'A server error occurred. Please try again or contact support.';
    } else {
      msg = data?.message || data?.error || err.message || 'Request failed';
      if (typeof msg !== 'string') msg = 'Request failed';
      // For unique-constraint violations, append the field name so the operator
      // knows what's already taken (e.g. "Unique constraint violated — externalRef").
      if (data?.fields) {
        const fields = Array.isArray(data.fields) ? data.fields.join(', ') : String(data.fields);
        msg = `${msg} — ${fields}`;
      }
    }
    toast.error(msg);
    return Promise.reject(err);
  },
);
